import React from 'react';
import ArrowOutwardIcon from '@mui/icons-material/ArrowOutward';
import { useNavigate } from 'react-router-dom';
import { useQuery } from 'react-query';
import useStore from '../../../Store/Store';
import { getDailyEvents, getUserDailyEvents } from '../../../utils/api';
import { Avatar, Skeleton } from '@mui/material';
import { isEmpty } from 'lodash';
import AddIcon from '@mui/icons-material/Add';

const TasksCard = () => {
  const history = useNavigate();
  const width = useStore((state) => state.screenWidth);
  const user = useStore((state) => state.user);
  const selectedRecipient = useStore((state) => state.selectedRecipient);

  const { data, isLoading } = useQuery(
    ['getDailyEvents', 'getUserDailyEvents', selectedRecipient],
    () => {
      if (isEmpty(selectedRecipient)) {
        return getDailyEvents({ userId: user?._id || user?.id, fromDashboard: '1' });
      } else {
        return getUserDailyEvents({
          userId: user?._id || user?.id,
          recipientId: selectedRecipient,
          fromDashboard: '1',
        });
      }
    },
    {
      retry: false,
      cacheTime: 0,
    },
  );

  return (
    <>
      {isLoading ? (
        <div className="pill-reminder top-margin-card" style={{ padding: 0 }}>
          <Skeleton animation="wave" height={'100%'} width="100%" />
        </div>
      ) : (
        <div className="tasks top-margin-card" style={{ marginLeft: width > 550 ? '10px' : '0px' }}>
          <div className="frame-ba">
            <span className="tasks-bb">Tasks</span>
            <div className="button-bc">
              <div className="arrow-up-right-bd" onClick={() => history('/calendar')}>
                <ArrowOutwardIcon fontSize="14px" />
              </div>
            </div>
          </div>
          <div className="frame-80">
            {isEmpty(data?.data) ? (
              <>
                <div className="empty-data">There is no data</div>
                <button
                  className="button-8f"
                  style={{ width: '180px', alignSelf: 'center' }}
                  onClick={() => history('/calendar?addEvent=1')}
                >
                  <AddIcon style={{ fontSize: '17px', color: '#fff' }} />
                  <span style={{ color: '#fff' }}>Add Tasks</span>
                </button>
              </>
            ) : (
              data?.data?.map((item) => (
                <div className="task">
                  <div className="frame-c0">
                    <div className="frame-c1">
                      <div className="avatars-c2">
                        {isEmpty(item?.userProfile) ? (
                          <Avatar style={{ width: '25px', height: '25px' }} />
                        ) : (
                          <Avatar src={item?.userProfile} alt="dp" style={{ width: '25px', height: '25px' }} />
                        )}
                      </div>
                    </div>
                    <button className="tags-c4">
                      <span className="label-c5">
                        {item?.start} - {item?.end}
                      </span>
                    </button>
                  </div>
                  <span className="meeting-with-peters-doctor">{item?.title}</span>
                </div>
              ))
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default TasksCard;
